<template>
    <div>

        <!-- Table -->

        <trax-training-course-edit-map :id="id" :bus="bus" :endpoint="endpoint" 
            :new-category-label="lang.polaris.training.new_section" :endpoint-params="endpointParams"
            :index-id="courseId" drag="1">
        </trax-training-course-edit-map>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-course-edit-item-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus" :endpoint="endpoint" 
                :type-code-select="learning_unit_types_select" :index-id="courseId" with-description="1">
            </trax-training-course-edit-item-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-course-edit-items'},
            courseId: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/sections',
                learning_unit_types_select: data.learning_unit_types_select,
                endpointParams: {
                    with: ['type']
                },
                bus: new Vue()
            }
        }
    }
</script>
